import type {FetchWrapper} from '@/ts/api/fetch-wrapper';
import type {SignUpRequest, ValidateVoucherRequest, ValidateVoucherResponse} from '@/ts/types/dto/sign-in-dto';
import type {GetLegalDocsResponse} from '@/ts/types/dto/tos-dto';
import type {
  ChangePasswordRequest,
  ResetPasswordRequest,
} from '@/ts/types/dto/change-password-dto';
import type {
  ResendVerificationEmailRequest,
  VerifyEmailRequest,
} from '@/ts/types/dto/verify-email-dto';

/**
 * {@link https://api-dev.ip.significo.dev/swagger-ui/index.html?urls.primaryName=public|Public API}
 */
export class PublicApi {
  public constructor(private readonly fetch: FetchWrapper) {
  }

  public async signUp(body: SignUpRequest): Promise<void> {
    return this.fetch.post({
      url: '/users',
      body,
    });
  }

  public async getLegalDocs(voucherCode?: string | null): Promise<GetLegalDocsResponse> {
    // eslint-disable-next-line no-undefined
    const queryParams = voucherCode ? {voucherCode} : undefined;
    return this.fetch.get({
      url: '/legal-docs',
      queryParams,
    });
  }

  public async verifyEmail(body: VerifyEmailRequest): Promise<void> {
    return this.fetch.post({
      url: '/verify-email',
      body,
      emptyResponse: true,
    });
  }

  public async resendVerificationEmail(body: ResendVerificationEmailRequest): Promise<void> {
    return this.fetch.post({
      url: '/resend-verification-email',
      body,
      emptyResponse: true,
    });
  }

  public async changePassword(body: ChangePasswordRequest): Promise<void> {
    return this.fetch.put({
      url: '/change-password',
      body,
      emptyResponse: true,
    });
  }

  public async resetPassword(body: ResetPasswordRequest): Promise<void> {
    return this.fetch.post({
      url: '/reset-password',
      body,
      emptyResponse: true,
    });
  }

  public async validateVoucher(body: ValidateVoucherRequest): Promise<ValidateVoucherResponse> {
    return this.fetch.get({
      url: `/validate-voucher-code/${body.voucherCode}`,
    });
  }
}
